import { lifeColor, lifeStrongColor } from "../../../../constants/colors";
import { styled } from "@mui/material/styles";

const stylesCss = {
  selectedTab: {
    "& .css-1aquho2-MuiTabs-indicator ": { backgroundColor: lifeColor },
    "& .css-1h9z7r5-MuiButtonBase-root-MuiTab-root.Mui-selected": {
      color: lifeStrongColor,
      backgroundColor: "white",
    },
    backgroundColor: "#f9fafc",
    border: "1px solid #dee3ed",
  },
};
const Content = styled("div")(({ theme }) => ({
  margin: "auto",
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  background: "#e9f7ff",
  [theme.breakpoints.down("md")]: {
    padding: "8px",
  },
  //   [theme.breakpoints.down("sm")]: {
  //     minHeight: "500px",
  //   },
  boxShadow:
    "0 4px 8px 0 rgb(84 84 84 / 10%), 0 6px 20px 0 rgb(84 84 84 / 10%)",
}));
const H3 = styled("h4")(({ theme }) => ({
  padding: "25px",
  color: "black",
  [theme.breakpoints.down("md")]: {
    flexDirection: "column",
    padding: "20px",
  },
  textAlign: "left",
  paddingBottom: "15px",
}));
const H4 = styled("h5")(({ theme }) => ({
  paddingLeft: "60px",
  color: "grey",
  [theme.breakpoints.down("md")]: {
    flexDirection: "column",
    padding: "20px",
  },
  textAlign: "left",
  paddingBottom: "15px",
}));
export { Content, H3, H4 };
export default stylesCss;
